import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import Vue from 'vue';
import ListenersMixin from "../../mixins/listeners.js";
import { stopAndPrevent } from "../../utils/event.js";
import { slot } from "../../utils/private/slot.js";
import { addFocusFn } from "../../utils/private/focus-manager.js";
export default Vue.extend({
  name: 'QForm',
  mixins: [ListenersMixin],
  props: {
    autofocus: Boolean,
    noErrorFocus: Boolean,
    noResetFocus: Boolean,
    greedy: Boolean
  },
  computed: {
    onEvents: function onEvents() {
      return _objectSpread(_objectSpread({}, this.qListeners), {}, {
        submit: this.submit,
        reset: this.reset
      });
    }
  },
  mounted: function mounted() {
    this.validateIndex = 0;
    this.autofocus === true && this.focus();
  },
  activated: function activated() {
    if (this.shouldActivate !== true) {
      return;
    }
    this.autofocus === true && this.focus();
  },
  deactivated: function deactivated() {
    this.shouldActivate = true;
  },
  methods: {
    validate: function validate(shouldFocus) {
      var _this = this;
      var focus = typeof shouldFocus === 'boolean' ? shouldFocus : this.noErrorFocus !== true;
      var index = ++this.validateIndex;
      var registeredComponents = this.getValidationComponents().filter(function (c) {
        return c.disable !== true;
      });
      var emit = function emit(res, ref) {
        _this.$emit('validation-' + (res === true ? 'success' : 'error'), ref);
      };
      var validateComponent = function validateComponent(comp) {
        var valid = comp.validate();
        return typeof valid.then === 'function' ? valid.then(function (valid) {
          return {
            valid: valid,
            comp: comp
          };
        }, function (err) {
          return {
            valid: false,
            comp: comp,
            err: err
          };
        }) : Promise.resolve({
          valid: valid,
          comp: comp
        });
      };
      var errorsPromise = this.greedy === true ? Promise.all(registeredComponents.map(validateComponent)).then(function (res) {
        return res.filter(function (r) {
          return r.valid !== true;
        });
      }) : registeredComponents.reduce(function (acc, comp) {
        return acc.then(function () {
          return validateComponent(comp).then(function (r) {
            if (r.valid === false) {
              return Promise.reject(r);
            }
          });
        });
      }, Promise.resolve()).catch(function (error) {
        return [error];
      });
      return errorsPromise.then(function (errors) {
        if (errors === void 0 || errors.length === 0) {
          index === _this.validateIndex && emit(true);
          return true;
        }
        if (index === _this.validateIndex) {
          var _errors$ = errors[0],
            comp = _errors$.comp,
            err = _errors$.err;
          err !== void 0 && console.error(err);
          emit(false, comp);
          if (focus === true) {
            // Try to focus first mounted and active component
            var activeError = errors.find(function (_ref) {
              var comp = _ref.comp;
              return typeof comp.focus === 'function' && comp._isBeingDestroyed !== true && comp._isDestroyed !== true && comp._inactive !== true;
            });
            if (activeError !== void 0) {
              activeError.comp.focus();
            }
          }
        }
        return false;
      });
    },
    resetValidation: function resetValidation() {
      this.validateIndex++;
      this.getValidationComponents().forEach(function (comp) {
        typeof comp.resetValidation === 'function' && comp.resetValidation();
      });
    },
    submit: function submit(evt) {
      var _this2 = this;
      evt !== void 0 && stopAndPrevent(evt);
      var index = this.validateIndex + 1;
      this.validate().then(function (val) {
        // if not outdated && validation succeeded
        if (index === _this2.validateIndex && val === true) {
          if (_this2.qListeners.submit !== void 0) {
            _this2.$emit('submit', evt);
          } else if (evt !== void 0 && evt.target !== void 0 && typeof evt.target.submit === 'function') {
            evt.target.submit();
          }
        }
      });
    },
    reset: function reset(evt) {
      var _this3 = this;
      evt !== void 0 && stopAndPrevent(evt);
      this.$emit('reset');
      this.$nextTick(function () {
        // allow userland to reset values before
        _this3.resetValidation();
        if (_this3.autofocus === true && _this3.noResetFocus !== true) {
          _this3.focus();
        }
      });
    },
    focus: function focus() {
      var _this4 = this;
      addFocusFn(function () {
        if (!_this4.$el) {
          return;
        }
        var target = _this4.$el.querySelector('[autofocus][tabindex], [data-autofocus][tabindex]') || _this4.$el.querySelector('[autofocus] [tabindex], [data-autofocus] [tabindex]') || _this4.$el.querySelector('[autofocus], [data-autofocus]') || Array.prototype.find.call(_this4.$el.querySelectorAll('[tabindex]'), function (el) {
          return el.tabIndex > -1;
        });
        target !== null && target !== void 0 && target.focus({
          preventScroll: true
        });
      });
    },
    getValidationComponents: function getValidationComponents() {
      return Array.prototype.map.call(this.$el.getElementsByClassName('q-validation-component'), function (field) {
        return field.__vue__;
      }).filter(function (c) {
        return c !== void 0 && typeof c.validate === 'function';
      });
    }
  },
  render: function render(h) {
    return h('form', {
      staticClass: 'q-form',
      on: this.onEvents
    }, slot(this, 'default'));
  }
});